import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  AfterViewInit,
  OnDestroy,
  Optional,
  Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { RupiahPipe } from '../pipes/rupiah.pipe';

@Directive({
  selector: '[formatCurrency]',
  providers: [RupiahPipe],
})
export class FormatCurrencyDirective implements AfterViewInit, OnDestroy {
  @Input() fractionSize: number = 0;
  private el: HTMLInputElement;
  private sub?: Subscription;

  constructor(
    private elementRef: ElementRef,
    private rupiahPipe: RupiahPipe,
    @Optional() @Self() private control?: NgControl
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.formatInitial(), 0);

    if (this.control?.valueChanges) {
      this.sub = this.control.valueChanges.subscribe((val) => {
        if (document.activeElement === this.el) return;

        if (val === null || val === undefined || val === '') {
          this.el.value = '';
          return;
        }

        const parsed = this.rupiahPipe.parse(String(val));
        this.el.value = this.rupiahPipe.transform(
          parsed,
          '',
          this.fractionSize
        );
      });
    }
  }

  private formatInitial() {
    const ctrlVal = this.control?.value;
    const initial =
      ctrlVal !== undefined && ctrlVal !== null && ctrlVal !== ''
        ? String(ctrlVal)
        : this.el.value;

    if (initial != null && initial !== '') {
      const parsed = this.rupiahPipe.parse(initial);
      this.el.value = this.rupiahPipe.transform(parsed, '', this.fractionSize);
    }
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value: string) {
    this.el.value = this.rupiahPipe.parse(value);
  }

  @HostListener('input', ['$event'])
  onInput(event: any) {
    const input = event.target;
    const rawValue = this.rupiahPipe.parse(input.value);

    const caretPos = input.selectionStart || 0;
    const oldLength = input.value.length;

    // Saat input, format nilai tanpa fractionSize di sini karena sudah fix
    const formatted = this.rupiahPipe.transform(rawValue, '', 0);
    this.el.value = formatted;

    const newLength = formatted.length;
    const diff = newLength - oldLength;
    this.el.setSelectionRange(caretPos + diff, caretPos + diff);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    if (value) {
      const parsed = this.rupiahPipe.parse(value);
      const raw = parsed ? parseInt(parsed, 10) : 0;

      this.el.value = this.rupiahPipe.transform(raw, '', this.fractionSize);

      if (this.control?.control) {
        this.control.control.setValue(raw, { emitEvent: true });
      }
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
